import { Spacing } from '@persona-id/design-tokens';
import { useCallback, VFC } from 'react';
import styled from 'styled-components';

import { ReportForcedStatus, StepOverride } from 'dashboard/models/workflow-run-simulated';
import { StepOverrideBaseProps } from 'dashboard/views/DashboardWorkflowRunsSimulateShowView/WorkflowSimulateControlPanel/StepOverride/StepOverrideBaseProps';
import Radio from 'design-system/components/Radio';
import RadioGroup from 'design-system/components/RadioGroup';
import Spacer from 'design-system/components/Spacer';

interface OverrideRunReportProps extends StepOverrideBaseProps {}

const StyledText = styled.div`
  display: inline-block;
  font-weight: ${({ theme }) => theme.text.paragraph.mdBold.fontWeight};
  margin-bottom: 0px;
`;

const OverrideConfigContainer = styled.div`
  padding: ${Spacing[2]} ${Spacing[5]} ${Spacing[2]} ${Spacing[1]};
  flex: auto;
  overflow-y: auto;
  margin-top: 1px;
`;

const getStatusStub = (simulateContext: StepOverride | undefined) => {
  if (simulateContext != null && 'status-stub' in simulateContext) {
    return simulateContext['status-stub'];
  }
  return ReportForcedStatus.NotMatched;
};

const OverrideRunReport: VFC<OverrideRunReportProps> = ({
  step,
  simulateContext,
  setSimulateContext,
  disabled,
}) => {
  const setStatusStubs = useCallback(
    (status: ReportForcedStatus) => {
      setSimulateContext({
        ...simulateContext,
        overrides: {
          ...simulateContext.overrides,
          steps: {
            ...simulateContext.overrides?.steps,
            [step.token]: {
              'status-stub': status,
            },
          },
        },
      });
    },
    [step.token, simulateContext, setSimulateContext],
  );
  const statusStub = getStatusStub(simulateContext.overrides?.steps?.[step.token]);
  return (
    <OverrideConfigContainer>
      <StyledText>Match results</StyledText>
      <Spacer height={1} />
      <RadioGroup id='match-config' onChange={setStatusStubs} value={statusStub}>
        <Radio
          key='report-no-match'
          label='No Match'
          value={ReportForcedStatus.NotMatched}
          disabled={disabled}
        />
        <Radio
          key='report-match'
          label='Match'
          value={ReportForcedStatus.Matched}
          disabled={disabled}
        />
      </RadioGroup>
    </OverrideConfigContainer>
  );
};

export default OverrideRunReport;
